import React, { useRef, useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ColorPicker } from "@vtaits/react-color-picker";
import "@vtaits/react-color-picker/index.css";
import { ucFirst } from "helpers/common";
import { PLANETS } from "helpers/constants";

const NewPlanetPopup = ({
  showPopup,
  setShowPopup,
  onChoosePlanet,
}) => {
  const [planet, setPlanet] = useState(null);

  const handleNext = () => {
    if(!planet) {
      alert("Please choose a planet");
    }
    onChoosePlanet(planet);
    handleClose();
  }

  const handleClose = () => {
    setPlanet(null);
    setShowPopup(false);
  }

  const handleSelectPlanet = (e) => {
    setPlanet(e.target.value);
  }

  return (
    <Modal
      show={showPopup}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      className="stockData PlanetPopup"
    >
      <Modal.Body>
        <div className="topHeader d-flex align-items-start justify-content-between pb-2">
          <div className="left">
            <div
              className="px-2 py-1 d-flex align-items-center justify-content-center"
            >
              <p className="m-0 fw-sbold text-capitalize">Choose Planet</p>
            </div>
          </div>

          <Button
            onClick={handleClose}
            className="border-0 p-0"
            variant="transparent"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M14.34 -0.000732422C17.73 -0.000732422 20 2.37927 20 5.91927V14.0903C20 17.6203 17.73 19.9993 14.34 19.9993H5.67C2.28 19.9993 0 17.6203 0 14.0903V5.91927C0 2.37927 2.28 -0.000732422 5.67 -0.000732422H14.34ZM13.01 6.97027C12.67 6.62927 12.12 6.62927 11.77 6.97027L10 8.74927L8.22 6.97027C7.87 6.62927 7.32 6.62927 6.98 6.97027C6.64 7.31027 6.64 7.87027 6.98 8.20927L8.76 9.99027L6.98 11.7603C6.64 12.1103 6.64 12.6603 6.98 12.9993C7.15 13.1693 7.38 13.2603 7.6 13.2603C7.83 13.2603 8.05 13.1693 8.22 12.9993L10 11.2303L11.78 12.9993C11.95 13.1803 12.17 13.2603 12.39 13.2603C12.62 13.2603 12.84 13.1693 13.01 12.9993C13.35 12.6603 13.35 12.1103 13.01 11.7703L11.23 9.99027L13.01 8.20927C13.35 7.87027 13.35 7.31027 13.01 6.97027Z"
                fill="#EB5757"
              />
            </svg>
          </Button>
        </div>

        <div className="cardBody py-3">
          <Form>
            <Row>
              <Col lg="12" className="my-2">
                <label htmlFor="" className="form-label text-dark">
                  Select Planet
                </label>

                <Form.Select
                  aria-label="Default select example"
                  className="form-control"
                  onChange={handleSelectPlanet}
                >
                  <option value="">Choose a Planet</option>
                  {Object.entries(PLANETS).map(([key, name]) => (
                    <option key={key} value={key}>{ucFirst(name)}</option>
                  ))}
                </Form.Select>
              </Col>
              <Col lg="12">
                <div className="btnWrpper mt-4 d-flex gap-10 justify-content-end">
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn borderedBtn"
                    onClick={handleNext}
                  >
                    Next
                  </Button>
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn borderedBtn btn-danger"
                    variant="danger"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default NewPlanetPopup;
